export function formatDate(date) {
  if (!date) return null;

  const [year, month, day] = date.split('-');
  return `${day}.${month}.${year}`;
}

export function formatPreAdmissionDate(date) {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');

  return year + '-' + month + '-' + day;
}

export function parseDate(date) {
  if (!date) return null;

  const [month, day, year] = date.split('/');
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
}

export function parseInsuranceCardExpirationDate(date) {
  if (!date) return null;

  const [day, month, year] = date.split('/');
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
}
